import GenerationEventSnippet from "../../../../contents/docs/llm-analytics/_snippets/generation-event.mdx";
import NotableGenerationPropertiesSnippet from "../../../../contents/docs/llm-analytics/_snippets/notable-generation-properties.mdx";
import * as React from 'react';
export default {
  GenerationEventSnippet,
  NotableGenerationPropertiesSnippet,
  React
};